// InteractChatAIDto.js

class InteractChatAIDto {
    actionType = String();
    actionDetail = String();

    actionDate = String();
    sessionId = String();
    destinationOrgId = String();
    destinationOrgDomain = String();
    destinationOrgName = String();
    destinationPrjId = String();
    destinationPrjName = String();
    orgActionId = String();
    orgActionDomain = String();
    orgActionName = String();
    prjActionId = String();
    prjActionName = String();
    userActionId = String();
    userActionEmail = String();
    userActionName = String();

    hitNumber = Number();
    aiChatScreen = String();
    aiTabChatName = String();
    aiChatInquiryText = String();
    knowIDRefInAiChatInquiry = String();
    userSelectedPromptID = String();
    userSelectedPromptName = String();
    basicPromptID = String();
    basicPromptName = String();
    aiChatAnswerText = String();
    searchCondition = String();
    qaCategoryId = String();
    tagFieldsSelected = Array()

    constructor(data) {
        this.actionType = data.actionType;
        this.actionDetail = data.actionDetail;

        this.actionDate = data.actionDate;
        this.sessionId = data.sessionId;
        this.destinationOrgId = data.destinationOrgId;
        this.destinationOrgDomain = data.destinationOrgDomain;
        this.destinationOrgName = data.destinationOrgName;
        this.destinationPrjId = data.destinationPrjId;
        this.destinationPrjName = data.destinationPrjName;
        this.orgActionId = data.orgActionId;
        this.orgActionDomain = data.orgActionDomain;
        this.orgActionName = data.orgActionName;
        this.prjActionId = data.prjActionId;
        this.prjActionName = data.prjActionName;
        this.userActionId = data.userActionId;
        this.userActionEmail = data.userActionEmail;
        this.userActionName = data.userActionName;

        this.hitNumber = data.hitNumber;
        this.aiChatScreen = data.aiChatScreen;
        this.aiTabChatName = data.aiTabChatName;
        this.aiChatInquiryText = data.aiChatInquiryText;
        this.knowIDRefInAiChatInquiry = data.knowIDRefInAiChatInquiry;
        this.userSelectedPromptID = data.userSelectedPromptID;
        this.userSelectedPromptName = data.userSelectedPromptName;
        this.basicPromptID = data.basicPromptID;
        this.basicPromptName = data.basicPromptName;
        this.aiChatAnswerText = data.aiChatAnswerText;
        this.searchCondition = data.searchCondition;
        this.qaCategoryId = data.qaCategoryId;
        this.tagFieldsSelected = data.tagFieldsSelected
    }
}

export default InteractChatAIDto;
